"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataType;
(function (DataType) {
    DataType["block"] = "block";
    DataType["theme"] = "theme";
    DataType["user"] = "user";
})(DataType = exports.DataType || (exports.DataType = {}));
